import React from 'react';
import TranslatedField from './TranslatedField';
import Input from './Input';
import { formatZipcode } from 'common/formatters/ZipCode';

const ZipCode = ({ label, ...props }) => (
  <TranslatedField
    name="zipcode"
    type="text"
    label={label}
    component={Input}
    format={value => {
      return formatZipcode(value, gon.current_store.cart_tax_country_iso);
    }}
    {...props}
  />
);

export default ZipCode;
